import classNames from "classnames";
import React, { FC } from "react";

import useDiningTimerHHMM from "../../common/hooks/useDiningTimerHHMM";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import "./DiningTimer.scss";

interface IDiningTimerProps {
	"data-testid"?: string;
	className?: string;
}

const DiningTimer: FC<IDiningTimerProps> = (props) => {
	const { state: orderUntil } = useConfigContext((state) => state.qrSession?.order_until);
	const display = useDiningTimerHHMM(orderUntil);

	if (!display) return null;

	return (
		<span
			className={classNames("DiningTimer", props.className)}
			data-testid={props["data-testid"] ?? "DiningTimer"}
		>
			{display}
		</span>
	);
};

export default DiningTimer;
